import {addDate, today} from "../../utils/date-object";
import {AcceptableFulfillmentDate} from "./acceptable-fulfillment-date";

export const getDefaultFulfillmentDate = ({holidays}) => {
    const isAcceptableDate = AcceptableFulfillmentDate({holidays});
    const today1 = today();
    if (isAcceptableDate(today1) && new Date().getHours() < 16) {
        return today1;
    } else {
        let d = today1;
        for (let i = 0; i < 30; i++) {
            d = addDate(d, 1);
            if (isAcceptableDate(d)) {
                return d;
            }
        }
    }
};
